import createApiClient from './client'

const apiClient = createApiClient('/auth-service')
// "forgot password" lives in the CRM backend (it sends the email); no sign-in, no tenant
const crmPublic = createApiClient('/executions')

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''
const API_VERSION = import.meta.env.VITE_API_VERSION || '/api/v1'

export const authAPI = {
  /** Providers set up for this installation → [{ id, name }] */
  ssoProviders: () => apiClient.get('/auth/sso/providers', { skipAuthRedirect: true }).then((r) => r.data),
  /** Where the browser goes (a full page load) to sign in with a provider; `next` = app path afterwards. */
  ssoStartUrl: (providerId, next) =>
    `${API_BASE_URL}/auth-service${API_VERSION}/auth/sso/${providerId}/start${next ? `?next=${encodeURIComponent(next)}` : ''}`,
  /** The one-time code from /sso/complete → a session (same shape as login). */
  ssoExchange: (code) => apiClient.post('/auth/sso/exchange', { code }, { skipAuthRedirect: true }).then((r) => r.data),
  /** Returns { userId, email, accessToken, refreshToken, tokenType, expiresIn } */
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password }, { skipAuthRedirect: true })
    return response.data
  },
  /** Ends this browser's session on the server (its refresh token stops working). Never throws. */
  logout: (refreshToken) =>
    apiClient.post('/auth/logout', { refreshToken }, { skipAuthRedirect: true }).catch(() => undefined),
  /** Ends every session of the signed-in person → { sessionsEnded } */
  logoutAll: () => apiClient.post('/auth/logout-all').then((r) => r.data),
  /** Every session ends; the answer is a fresh session for this browser (same shape as login). */
  changePassword: (currentPassword, newPassword) =>
    apiClient.post('/auth/password/change', { currentPassword, newPassword }, { skipAuthRedirect: true }).then((r) => r.data),
  /** From the emailed link; then sign in with the new password. */
  resetPassword: (token, newPassword) =>
    apiClient.post('/auth/password/reset', { token, newPassword }, { skipAuthRedirect: true }).then((r) => r.data),
  /** Same answer whether or not the address has an account; 409 when email isn't set up. */
  forgotPassword: (email) =>
    crmPublic.post('/public/password/forgot', { email }, { skipAuthRedirect: true }).then((r) => r.data),
}
